export const commonConfig = {
  darkTheme: false,
  classicHeader: false,
};
